import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { HttpApiService } from '@recruitee/http';

import { FeatureFlag } from '../types';

@Injectable({ providedIn: 'root' })
export class FeatureFlagsHttpService {
  constructor(private httpApi: HttpApiService) {}

  public loadFeatureFlagsList(): Observable<{ features: FeatureFlag[] }> {
    return this.httpApi.get('/features');
  }
}
